import { enable_async_mode_flag } from './index.js';

enable_async_mode_flag();
